import { render, staticRenderFns } from "./shijian2.vue?vue&type=template&id=5b331192&scoped=true&"
import script from "./shijian2.vue?vue&type=script&lang=js&"
export * from "./shijian2.vue?vue&type=script&lang=js&"
import style0 from "./shijian2.vue?vue&type=style&index=0&id=5b331192&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b331192",
  null
  
)

export default component.exports